import React from 'react';
import { useEntityListData } from './useEntityListData';
import { ConfigurationRuleScopeEntityType } from '@ydistri/api-sdk';
import type { CustomTagProps } from 'rc-select/lib/BaseSelect';
import ConfigurationMultiselectTag from '../../../components/global/ConfigurationMultiselect/ConfigurationMultiselectTag';

interface MultiselectTagProps extends Partial<CustomTagProps> {
  entityType: ConfigurationRuleScopeEntityType;
  entityId: number;
  error?: React.ReactNode;
  warning?: React.ReactNode;
  onClick?: () => void;
}

const MultiselectTag: React.FC<MultiselectTagProps> = ({
  entityType,
  closable,
  onClose,
  onClick,
  entityId,
  error,
  warning,
  disabled,
  label,
}) => {
  const { data } = useEntityListData(entityType);
  const displayedLabel = label ?? data?.object[entityId]?.name;

  if (!data) return null;

  return (
    <ConfigurationMultiselectTag
      closable={closable}
      disabled={disabled}
      error={error}
      label={displayedLabel}
      onClick={onClick}
      onClose={onClose}
      warning={warning}
    />
  );
};

export default MultiselectTag;
